export const LOADING_CELL_TEXT = "Loading..."
